import * as React from 'react';
import Container from '@mui/material/Container';
import Timeline from '@mui/lab/Timeline';
import TimelineOppositeContent, {
  timelineOppositeContentClasses,
} from '@mui/lab/TimelineOppositeContent';

import DayTimelineItem from './DayTimelineItem.tsx'
import RehearsalDinnerTimelineItem from './RehearsalDinnerTimelineItem.tsx'

export default function RehearsalTimeline() {
  return (
    <Container sx={{
      minWidth: "400",
      display: 'flex',
      m: 0,
      p: 0,
    }}>
       <Timeline sx={{
        m:0,
        p:0,
        [`& .${timelineOppositeContentClasses.root}`]: {
          flex: 0.25,
        },
      }}>
        <DayTimelineItem date="5/09" dayOfWeek='Friday' title='May 9th'/>
        <RehearsalDinnerTimelineItem />
    </Timeline>
    </Container>
  );
}
